export default "__VITE_ASSET__BTxZ$9ON__"